'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/messaging/conversation-action-feature'
import { EnsureBalanceActivated } from '@marketplace-web/domain/balance-activation'

import CustomShippingInstructionsModal from '../CustomShippingInstructionsModal'

type Props = ConversationActionProps

const CustomShipmentInstructions = ({ action, title, primary, size, theme, inverse }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalOpen = () => setIsModalOpen(true)

  const handleModalClose = () => setIsModalOpen(false)

  if (!transactionId) return null

  return (
    <EnsureBalanceActivated
      action={action}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onSuccess={handleModalOpen}
      title={title}
    >
      <>
        <ConversationActionButton
          primary={primary}
          text={title}
          size={size}
          theme={theme}
          inverse={inverse}
          onClick={handleModalOpen}
        />
        {isModalOpen && (
          <CustomShippingInstructionsModal
            onClose={handleModalClose}
            transactionId={transactionId}
          />
        )}
      </>
    </EnsureBalanceActivated>
  )
}

export default CustomShipmentInstructions
